import { useState } from "react";
import i18n from "../../i18n";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";



export function LanguageSelector() {

    const [showSelector, setShowSelector] = useState(false);
    const t = i18n.t;


    const changeLanguage = (lng: string) => {
        i18n.changeLanguage(lng);
        window.location.href = "../../../../";

    };


    const toggleLanguageSelector = () => {
        setShowSelector(!showSelector);
    };





    const supportedLanguages = Object.keys(i18n.services.resourceStore.data);
    const codes = supportedLanguages.filter(lng => lng !== 'cimode');

    // 2. Map the codes to their native names
    const languageList = codes.map(code => {
        try {
            // We pass the [code] itself so it returns the name in that language
            const generator = new Intl.DisplayNames([code], { type: 'language' });
            let nativeName = generator.of(code) || code;
            const formattedName = nativeName.charAt(0).toUpperCase() + nativeName.slice(1);
            return {
                code: code,
                nativeName: formattedName
            };
        } catch (e) {
            // Fallback to the code if the browser can't resolve the name
            return { code: code, nativeName: code };
        }
    });



    return <>
        <div className="language_selector">
            <a href="#!"
                tabIndex={0}
                onKeyUp={(e) => (e.key === 'Enter' || e.key === ' ') && toggleLanguageSelector()}
                onClick={(e) => {
                    e.preventDefault(); toggleLanguageSelector();
                }}
            >{t("header_language")} <FontAwesomeIcon icon={faAngleRight} /></a>
            {showSelector && <>
                <div className="language_options">
                    {languageList.map(lang => (
                        <a key={lang.code}
                            tabIndex={0} href="#!"
                            onKeyUp={(e) => (e.key === 'Enter' || e.key === ' ') && changeLanguage(lang.code)}
                            onClick={() => changeLanguage(lang.code)}
                        >{lang.nativeName} <FontAwesomeIcon icon={faAngleRight} /></a>
                    ))}
                </div>
            </>}
        </div>
        {showSelector && <div className="overlay" onClick={toggleLanguageSelector}></div >}

    </>


    // return (
    //     <div style={{ position: "fixed", top: 10, right: 10, zIndex: 1001, backgroundColor: "#FFF", padding: "10px", boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)", borderRadius: "5px" }}  >
    //         <div className="d-flex justify-content-start gap-1" style={{ marginBottom: "0.5em" }}>
    //             <select className="d-inline-block w-auto m-0" defaultValue={i18n.language} onChange={(e) => changeLanguage(e.target.value)}>
    //                 <option value="en">English</option>
    //                 <option value="fr">Français</option>
    //                 <option value="it">Italiano</option>
    //                 <option value="de">Deutsch</option>
    //                 <option value="es">Español</option>
    //                 <option value="tr">Türkçe</option>
    //                 <option value="pl">Polski</option>
    //             </select>
    //             <button style={{ flexShrink: 0 }} onClick={() => changeLanguage("en")}>Reset</button>
    //         </div>
    //         Language: {i18n.language}
    //     </div>
    // )
}  